import { rifledCategoryURL, smoothboreCategoryURL } from "../config.js";
import { getLocation } from "../healpers.js";
import icons from 'url:../../images/sprite.svg';

const weaponListScrollHeader = () => {
    const category = getLocation()
    const columnSettings = JSON.parse(localStorage.getItem(`${category === smoothboreCategoryURL ? 'smoothboreSettings' : 'rifledSettings'}`));
    const weaponListScrollHeaderContainer = document.querySelector('.thead-data-scroll')
    const filterBtnHTML = `
    <svg class="wd-icon filter-btn">
        <use xlink:href="${icons}#arrow-down"></use>
    </svg>
    `;
    
    let smoothboreColumns = '';
    let rifledColumns = '';
    if(category === smoothboreCategoryURL){
        smoothboreColumns = `
        <div class="thead-data data-col col-8" data-collapsible="8" data-filter-col="8" data-column-type="bulletLength">
            Длина патрона
            <svg class="wd-icon filter-btn">
                <use xlink:href="${icons}#arrow-down"></use>
            </svg>
        </div>
        <div class="thead-data data-col col-9" data-collapsible="9" data-filter-col="9" data-column-type="barrelLength">Длина ствола</div>
        `;
    }
    if(category === rifledCategoryURL) {
        rifledColumns = `
        <div class="thead-data data-col col-24" data-collapsible="24" data-filter-col="24" data-column-type="aim">Прицел</div>
        `;
    }

    let weaponListHeaderColumnHTML = `
    <div class="thead-data data-col col-6" data-collapsible="6" data-filter-col="6" data-column-type="subtype">
        Тип
        <svg class="wd-icon filter-btn">
            <use xlink:href="${icons}#arrow-down"></use>
        </svg>
    </div>
    <div class="thead-data data-col col-7" data-collapsible="7" data-filter-col="7" data-column-type="caliber">
        Калибр
        <svg class="wd-icon filter-btn">
            <use xlink:href="${icons}#arrow-down"></use>
        </svg>
    </div>
    ${rifledColumns}
    ${smoothboreColumns}
    <div class="thead-data data-col col-10" data-collapsible="10" data-filter-col="10" data-column-type="trigger">
        Спуск. крючок
        <svg class="wd-icon filter-btn">
            <use xlink:href="${icons}#arrow-down"></use>
        </svg>
    </div>
    <div class="thead-data data-col col-11" data-collapsible="11" data-filter-col="11" data-column-type="purchasePrice">Цена покупки</div>
    <div class="thead-data data-col col-12" data-collapsible="12" data-filter-col="12" data-column-type="marketPrice">Цена рынок</div>
    <div class="thead-data data-col col-13" data-collapsible="13" data-filter-col="13" data-column-type="weaponNumber">№ Оружия</div>
    <div class="thead-data data-col col-14" data-collapsible="14" data-filter-col="14" data-column-type="case">
        Кейс
        <svg class="wd-icon filter-btn">
            <use xlink:href="${icons}#arrow-down"></use>
        </svg>
    </div>
    <div class="thead-data data-col col-15" data-collapsible="15" data-filter-col="15" data-column-type="term">РХ/РОХА</div>
    <div class="thead-data data-col col-16" data-collapsible="16" data-filter-col="16" data-column-type="passport">Паспорт</div>
    <div class="thead-data data-col col-17" data-collapsible="17" data-filter-col="17" data-column-type="productionYear">Год производства</div>
    <div class="thead-data data-col col-22" data-collapsible="22" data-filter-col="22" data-column-type="weaponCondition">Состояние ружья</div>
    <div class="thead-data data-col col-23" data-collapsible="23" data-filter-col="23" data-column-type="barrelCondition">Состояние ствола</div>
    <div class="thead-data data-col col-18" data-collapsible="18" data-filter-col="18" data-column-type="shelfNumber">Номер полки</div>
    <div class="thead-data data-col col-19" data-collapsible="19" data-filter-col="19"data-column-type="safe">Сейф</div>
    <div class="thead-data data-col col-20" data-collapsible="20" data-filter-col="20" data-column-type="choki">Чоки</div>
    <div class="thead-data data-col col-21" data-collapsible="21" data-filter-col="21" data-column-type="investEvaluation">Инвест. ценность</div>
    `;

    if(columnSettings) {
        weaponListHeaderColumnHTML = '';
        columnSettings.forEach((obj, index) => {
            weaponListHeaderColumnHTML += `
            <div class="thead-data data-col col-${obj.column} ${obj.open ? '' : 'hidden'}" data-collapsible="${obj.column}" data-filter-col="${obj.column}" data-column-type="${obj.columnType}">
                ${obj.name}
                ${obj.filter === "1" ? filterBtnHTML : ''}         
            </div>
            `;
        });
    }

    weaponListScrollHeaderContainer.insertAdjacentHTML('beforeend', weaponListHeaderColumnHTML)
}

export const weaponListHeader = () => {
    const weaponListHeaderContainer = `
        <div class="weapon-list-header">
            <div class="thead">
                <div class="thead-data-fixed">
                    <div class="thead-data col-1">Действия</div>
                    <div class="thead-data col-2">№</div>
                    <div class="thead-data col-3">№ РХ</div>
                    <div class="thead-data col-4" data-filter-col="4">
                        Производитель
                        <svg class="wd-icon filter-btn">
                            <use xlink:href="${icons}#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="thead-data col-5">Модель</div>
                </div>
                <div class="thead-data-scroll">

                </div>
            </div>
        </div>
    `;
    document.querySelector('.header').insertAdjacentHTML('beforeend', weaponListHeaderContainer)
    weaponListScrollHeader()
}